import { AxiosRequestConfig } from 'axios';
import Config from '@/config';
import http, { Method } from './http';

const CACHEABLE_BASE_PATHS = [
  `${Config.BFF_SERVICE.URL}/wmp-bff/sso/big-loyalty-api-key`,
  `${Config.BFF_SERVICE.URL}/wmp-bff/sso/big-loyalty-access-token`,
];

class HttpQueue {
  private requestMap: {
    [key: string]: any;
  } = {};
  private cacheableBasePaths = [];
  static instance: any;

  constructor() {
    if (!HttpQueue.instance) {
      this.requestMap = {};
      this.cacheableBasePaths = CACHEABLE_BASE_PATHS;
      HttpQueue.instance = this;
    }
    return HttpQueue.instance;
  }

  normalizeUrl(url) {
    let cacheKey = url;
    // check if the url starts with any of the path templates in the cacheableBasePaths array
    this.cacheableBasePaths.forEach((pathTemplate) => {
      if (url.startsWith(pathTemplate)) {
        cacheKey = pathTemplate; // if matched, use the template path as the cache key
      }
    });

    return cacheKey;
  }

  request<T>(
    method: Method,
    url: string,
    data?: object,
    config?: AxiosRequestConfig,
  ): Promise<any> {
    const cacheKey = this.normalizeUrl(url);
    if (this.requestMap[cacheKey]) {
      return this.requestMap[cacheKey];
    }

    const result = http.request<T>(method, url, data, config).finally(() => {
      delete this.requestMap[cacheKey];
    });

    this.requestMap[cacheKey] = result;
    return result;
  }

  post<T>(
    url: string,
    data?: object,
    config?: AxiosRequestConfig,
  ): Promise<any> {
    return this.request<T>(Method.POST, url, data, config);
  }

  get<T>(
    url: string,
    data?: object,
    config?: AxiosRequestConfig,
  ): Promise<any> {
    return this.request<T>(Method.GET, url, data, config);
  }
}

export default Object.freeze(new HttpQueue());
